package com.ai.mitra.di


import com.ai.mitra.data.respository.GeminiRepositoryImp
import com.ai.mitra.domain.respository.GeminiRepository
import org.koin.dsl.module


val geminiRepositoryModule = module {
    single<GeminiRepository> { GeminiRepositoryImp(get(), get()) }
}
